import React from "react";
import {Route, Switch} from "react-router-dom";
import {Button, Typography, Chip, Tab, Tabs} from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import {BrowserServiceSingleton} from "src/Context";
import {ReceiptLogTable} from "./component/ReceiptLogTable";
import {ReceiptLogDetailView} from "./component/ReceiptLogDetailView";
import {BrandListPage} from "../branding/component/BrandListPage";
import {BrandFormPage} from "../branding/component/BrandFormPage";
import "./InternalPage.scss";

/**
 * Internal admin area (after successful login + 2FA).
 *
 * Two tabs: the existing receipt-log view, and brand management. The tab bar is the only
 * structural change to the admin shell — the receipt-log components are untouched.
 */
export class InternalPage extends React.Component {
    private readonly browserService = BrowserServiceSingleton;

    private goToAdminLogin = () => {
        this.browserService.redirectTo("/admin-login");
    };

    /** Payments owns every /internal route except the branding subtree. */
    private activeTab(): string {
        const path = this.browserService.history.location.pathname;
        return path.indexOf("/internal/branding") === 0 ? "branding" : "payments";
    }

    private selectTab = (_: React.ChangeEvent<{}>, value: string) => {
        this.browserService.redirectTo(value === "branding" ? "/internal/branding" : "/internal");
    };

    render() {
        return (
            <div className="admin-dashboard">
                <div className="admin-dashboard-header">
                    <div style={{display: "flex", alignItems: "center", gap: 12}}>
                        <Typography variant="h5">Payment Application Admin Platform</Typography>
                        <Chip label="Internal" size="small" variant="outlined" color="primary" />
                    </div>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<ExitToAppIcon />}
                        onClick={this.goToAdminLogin}
                    >
                        Re-authenticate
                    </Button>
                </div>

                <div className="admin-dashboard-tabs">
                    <Tabs value={this.activeTab()} onChange={this.selectTab}
                          indicatorColor="primary" textColor="primary">
                        <Tab value="payments" label="Payments"/>
                        <Tab value="branding" label="Branding"/>
                    </Tabs>
                </div>

                <Switch>
                    <Route exact path="/internal" component={ReceiptLogTable}/>
                    <Route exact path="/internal/branding" component={BrandListPage}/>
                    <Route path="/internal/branding/:id" component={BrandFormPage}/>
                    <Route path="/internal/receipt/:id" component={ReceiptLogDetailView}/>
                </Switch>
            </div>
        );
    }
}
